module.exports = __webpack_public_path__ + "assets/img/27.064de07a.png";